<!-- 头像修改裁剪器 -->
<template>
  <div>
    <!-- :dialogStyle="{ top: '80px' }" -->
    <a-modal
      centered
      :maskClosable="false"
      :keyboard="false"
      :visible="visible"
      :title="$t('更换头像')"
      :width="width"
      :okText="okText"
      :confirmLoading="updateLoading"
      @ok="ok"
      @cancel="cancelModel"
    >
      <a-row type="flex" justify="center" align="middle" :gutter="[80, 0]">
        <a-col :span="13" style="border-right: 1px solid #e3e4e5; height: 200px">
          <a-upload
            v-show="!options.img"
            ref="avatar"
            accept="image/jpeg,image/jpg,image/png"
            list-type="picture-card"
            class="img-uploader-square wh200 right"
            :supportServerRender="true"
            :show-upload-list="false"
            :before-upload="avatarBeforeUpload"
            :customRequest="() => {}"
            @change="avatarChange"
          >
            <div>
              <div class="ant-upload-text">
                {{ $t('点击上传图片') }}
              </div>
            </div>
          </a-upload>
          <vueCropper
            v-if="options.img"
            ref="cropper"
            :style="{ width: '200px', height: '200px' }"
            style="float: right"
            :img="options.img"
            :autoCrop="options.autoCrop"
            :centerBox="options.centerBox"
            :info="options.info"
            :infoTrue="options.infoTrue"
            :full="options.full"
            :fixed="options.fixed"
            :canScale="options.canScale"
            :canMove="options.canMove"
            :original="options.original"
            :autoCropWidth="options.autoCropWidth"
            :autoCropHeight="options.autoCropHeight"
            :fixedBox="options.fixedBox"
            :fixedNumber="options.fixedNumber"
            :enlarge="options.enlarge"
            :mode="options.mode"
            @realTime="realTime"
          />
          <div v-if="options.img" style="width: 200px; float: right; text-align: center">
            <div class="restart-upload-btn" @click="restartAvatar">
              <a-icon type="sync" />
              <span>{{ $t('重新选择') }}</span>
            </div>
          </div>
        </a-col>
        <a-col :span="11">
          <div v-if="!options.img" class="avatar-previews-img">
            <img :src="memberAvatar" />
          </div>
          <div v-if="previews.html" class="avatar-previews-img" :style="previewStyle4">
            <div :style="previews.div">
              <img :src="previews.url" :style="previews.img" />
            </div>
          </div>
          <div style="width: 100px; text-align: center; margin-top: 20px">
            <span>{{ options.img ? '预览头像' : '当前头像' }}</span>
          </div>
          <!-- </div> -->
        </a-col>
      </a-row>
      <a-row type="flex" justify="center" style="margin-top: 60px">
        <a-col>
          {{ $t('请选择图片上传：大小200 * 200像素支持JPG、PNG格式,图片需小于5M') }}
        </a-col>
      </a-row>
    </a-modal>
  </div>
</template>
<script>
import { initUploadTask } from '@/api/uploadFile'
import { checkImageWH, sleep } from '@/utils/util'
import { DEFAULTS_AVATAR } from '@/const/image'

export default {
  name: 'BusinessAvatarCropper',
  props: {
    // 对话框显示
    visible: {
      type: Boolean,
      default: false,
    },
    // model宽度
    width: {
      type: String,
      default: '760px',
    },
    // 插件高度,建议根据需要裁剪的图片尺寸调整
    height: {
      type: String,
      default: '500px',
    },
  },
  data() {
    return {
      previewsWidth: 500,
      previewVisible: false,
      options: {
        // 裁剪图片的地址 url 地址 || base64 || blob
        img: '',
        // 裁剪生成图片的质量 0.1 - 1
        outputSize: 1,
        // 裁剪生成图片的格式 jpeg || png || webp
        outputType: 'jpeg',
        // 裁剪框的大小信息 true
        info: false,
        // 图片是否允许滚轮缩放 true || false
        canScale: true,
        // 是否默认生成截图框
        autoCrop: true,
        // 默认生成截图框宽度
        autoCropWidth: 0,
        // 默认生成截图框高度
        autoCropHeight: 0,
        // 是否开启截图框宽高固定比例
        fixed: true,
        // // 截图框的宽高比例 [宽度, 高度]
        fixedNumber: [1, 1],
        // 是否输出原图比例的截图 false
        full: false,
        // // 固定截图框大小 不允许改变 false  true | false
        fixedBox: false,
        // // 上传图片是否可以移动 true true | false
        canMove: true,
        // // 截图框能否拖动 true true | false
        canMoveBox: true,
        // // 上传图片按照原始比例渲染 false true | false
        original: false,
        // // 截图框是否被限制在图片里面 false true | false
        centerBox: true,
        // // 是否按照设备的dpr 输出等比例图片 true true | false
        // high: 'option.high',
        // true 为展示真实输出图片宽高 false 展示看到的截图框宽高 false true | false
        infoTrue: false,
        // 限制图片最大宽度和高度 2000 0-max
        // maxImgSize: 2000,
        // 图片根据截图框输出比例倍数 1 0-max(建议不要太大不然会卡死的呢)
        enlarge: '1',
        // // 图片默认渲染方式 contain , cover, 100px, 100% auto
        mode: 'contain',
      },
      previews: {},
      fileName: '',
      // 图片/文件上传
      picUrl: '',
      picOssData: {},
      updateLoading: false,
      okText: '更新',
    }
  },
  computed: {
    memberAvatar() {
      const avatar = this.$store.state.userInfo.avatar
      if (avatar) {
        return this.$store.state.userInfo.avatar
      }
      return DEFAULTS_AVATAR
    },
    previewStyle() {
      const previews = this.previews
      const cropperHeight = this.cropperHeight
      return {
        width: `${previews.w}px`,
        height: `${previews.h}px`,
        overflow: 'hidden',
        margin: 'auto',
        zoom: this.isLandscape ? this.previewWidth / previews.w : cropperHeight / previews.h,
      }
    },
  },
  mounted() {},
  methods: {
    edit(record) {
      const { options } = this
      // this.visible = true;
      this.$emit('update:visible', true)
      const config = { ...options, ...record }
      console.log('裁剪图配置：', config)
      // 设置预览宽度
      this.previewsWidth = config.autoCropWidth
      this.options = config
    },
    cancelModel() {
      // this.visible = false
      this.$emit('update:visible', false)
      this.previewVisible = false
      return false
    },
    getCropData() {
      this.$refs.cropper.getCropData((data) => {
        console.log(data)
      })
    },
    // 移动框的事件
    realTime(data) {
      console.log(data)
      const previews = data
      const h = 0.5
      const w = 0.2
      this.previewStyle1 = {
        width: `${previews.w}px`,
        height: `${previews.h}px`,
        overflow: 'hidden',
        margin: '0',
        zoom: h,
      }

      this.previewStyle2 = {
        width: `${previews.w}px`,
        height: `${previews.h}px`,
        overflow: 'hidden',
        margin: '0',
        zoom: w,
      }

      // 固定为100宽度
      this.previewStyle3 = {
        width: `${previews.w}px`,
        height: `${previews.h}px`,
        overflow: 'hidden',
        margin: '0',
        zoom: 100 / previews.w,
      }

      // 固定为100高度
      this.previewStyle4 = {
        width: `${previews.w}px`,
        height: `${previews.h}px`,
        overflow: 'hidden',
        margin: '0',
        zoom: 100 / previews.h,
      }
      // 如输出不满200,设置输出倍数到达200宽度
      if (previews.w && previews.w < 200) {
        this.options.enlarge = 200 / previews.w
        console.log('enlarge', previews.w, this.options.enlarge)
      }
      this.previews = data
      // this.previews = data
      // this.$set(this.previews, 'url', data.url)
      // this.$set(this.previews, 'url', data.url)
    },
    ok() {
      this.previewVisible = false
      // // 获取截图的blob数据
      this.$refs.cropper.getCropBlob((data) => {
        // do something
        console.log(window.URL.createObjectURL(data))
      })
      // 获取截图的base64 数据
      this.$refs.cropper.getCropData(async (data) => {
        const { options } = this
        console.log('getCropData', data)
        // 转换为File对象
        let file = ''
        if (data !== 'data:,') {
          file = this.$utils.dataURLtoFile(data, options.fileName)
        }

        file.uid = options.uid
        file.thumbUrl = data
        file.index = options.index
        // 上传
        this.updateLoading = true
        this.okText = '上传中'
        await sleep(500)
        const res = await this.avatarUpload(file)
        if (res.status === 204) {
          this.updateLoading = false
          this.cancelModel()
        }
      })
    },
    okBlob() {},
    restartAvatar() {
      console.log('文件')
      const avatar = this.$refs.avatar.$el.firstChild.firstChild.firstChild
      avatar.click()
      window.test = avatar
    },
    // 会员头像上传前的验证
    async avatarBeforeUpload(file, type) {
      // 格式验证
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
      if (!isJpgOrPng) {
        this.$message.error(this.$t('只可以上传jpg/png 格式的图片'))
        return Promise.reject('文件校验失败')
      }
      // 分辨率验证
      const checkWH = await checkImageWH(file, 50, 50, '>=')
      if (checkWH.verify === 0) {
        this.$message.error(this.$t(`请上传 50*50 尺寸以上图片,当前图片 ${checkWH.width}*${checkWH.height}`))
        return Promise.reject('文件校验失败')
      } else if (checkWH.verify === -1) {
        this.$message.error(`( ° △ °|||) ${this.$t('图片解析失败,请确保图片是正确的')}`)
        return Promise.reject('文件校验失败')
      }
      // 大小
      const isLt2M = file.size / 1024 / 1024 < 5
      if (!isLt2M) {
        this.$message.error(this.$t('图片大小不可以超过 5MB!'))
        return Promise.reject('文件校验失败')
      }
      return Promise.resolve('校验通过')
    },
    // 会员头像自定义上传逻辑
    async avatarUpload(files) {
      if (!files) {
        return console.log('没有上传的文件信息')
      }
      const file = files
      const filename = 'file'
      // this.$set(this.skusPicLoading, [i], true)
      console.log('自定义上传逻辑', files)
      // 初始化上传
      const uploadUrl = await initUploadTask('image', file.name)
      this.picUrl = uploadUrl.data.host
      this.picOssData = uploadUrl.data.para
      const action = this.picUrl

      const param = new FormData()
      // 将得到的文件流添加到FormData对象
      const data = this.picOssData
      for (const key in data) {
        // eslint-disable-next-line no-prototype-builtins
        if (data.hasOwnProperty(key)) {
          const value = data[key]
          console.log(key, value)
          param.append(key, value)
        }
      }

      param.append(filename, file, file.name)
      const oss = await this.$axios.post(action, param, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      file.status = 'done'
      file.response = oss
      console.log('oss-callback', oss)
      this.avatarChange({ file })
      return oss
    },
    // 会员头像上传事件
    avatarChange({ file, fileList }) {
      console.log('avatarChange', file)
      if (file.status === 'uploading') {
        this.$utils.getBase64(file.originFileObj, (imageUrl) => {
          const target = {
            autoCropWidth: 200,
            autoCropHeight: 200,
            fileName: file.name,
            uid: file.uid,
            img: imageUrl,
          }
          this.edit(target)
        })
        // return
      }
      if (file.status === 'done') {
        const ossUrl = `${this.picUrl}/${this.picOssData.key}`
        // 将上传好的ossUrl返回给父组件
        this.$emit('ok', ossUrl)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.result-wrapper {
  margin-top: 20px;
  width: 100%;
  display: flex;
  padding: 20px;
  justify-content: center;
  .tar-img {
    overflow: hidden;
  }
}
.restart-upload-btn {
  margin-top: 10px;
  cursor: pointer;
  font-size: 14px;
  color: $second-color;
  &:hover {
    color: $primary-color;
  }
}
.avatar-previews-img {
  width: 100px;
  height: 100px;
  line-height: 100px;
  font-size: 18px;
  border-radius: 4px;
  background: transparent;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  list-style: none;
  font-feature-settings: 'tnum', 'tnum';
  position: relative;
  display: inline-block;
  overflow: hidden;
  color: #fff;
  white-space: nowrap;
  text-align: center;
  vertical-align: middle;
  background: #ccc;
  > img {
    display: block;
    width: 100%;
    height: 100%;
    -o-object-fit: cover;
    object-fit: cover;
  }
}
</style>
